import React from 'react';

import GenericProduct from './Generic';
import EventProduct from './Event';

const Product = (props) => {
  const { entity } = props;

  const productType = entity.getIn(['type', 0, 'target_id']);
  if (productType === 'fysieke_training') {
    return <EventProduct {...props} />;
  }

  return <GenericProduct {...props} />;
};

export default Product;
